import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({
    title,
    description,
    keywords,
    image = '/media/opengraph.png',
    url = 'https://ibubbleiq.com',
    lang = 'en'
}) {
    const siteName = 'bobatea';
    const twitterHandle = '@ibubble_iq'; // Assuming this handle, update if different

    // Structured Data (JSON-LD) for LocalBusiness
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "bobatea",
        "image": [
            `${url}/media/logo.png`,
            `${url}/media/ibubble.png`
        ],
        "description": description,
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Area 115, Shirwana",
            "addressLocality": "Sulaymaniyah",
            "addressRegion": "Kurdistan Region",
            "addressCountry": "IQ"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": "35.55", // Approximate, update with exact coords if available
            "longitude": "45.43" // Approximate
        },
        "url": url,
        "telephone": "+9647701542782",
        "openingHoursSpecification": [
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday"
                ],
                "opens": "09:00",
                "closes": "23:00"
            }
        ],
        "sameAs": [
            "https://www.instagram.com/ibubble.iq/",
            "https://www.facebook.com/Ibubble.IQ/"
        ]
    };

    return (
        <Helmet htmlAttributes={{ lang }}>
            {/* Standard Metadata */}
            <title>{title} | {siteName}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <link rel="canonical" href={url} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="business.business" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={`${url}${image}`} />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:locale" content={lang === 'ar' ? 'ar_IQ' : lang === 'ku' ? 'ku_IQ' : 'en_US'} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content={twitterHandle} />
            <meta name="twitter:creator" content={twitterHandle} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={`${url}${image}`} />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
}
